// CustomSelect.js

import React from "react";
import Select from "react-select";
import Creatable from "react-select/creatable";

const MultiSelect = ({ field, ...allProps }) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "20px",
      minHeight: "40px",
      backgroundColor: state.isDisabled ? "#d9d9d9" : "#f0f6e2",
      border: "none",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "#aaa" : null,
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: "#f0f6e2",
      borderRadius: "0px",
      border: "1px solid black",
      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
      margin: 0,
      padding: 0,
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: "black",
      "&:hover": {
        color: "black",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "#fff" : "#333",
      backgroundColor: state.isSelected ? "#007bff" : null,
      "&:hover": {
        backgroundColor: "#1967d2",
        color: "#fff",
      },
      padding: "5px",
    }),
    multiValue: (provided, state) => ({
      ...provided,
      borderRadius: "5px",
      backgroundColor: "#fff",
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      cursor: "pointer",
      backgroundColor: "transparent",
      color: "inherit",
      marginTop: "-10px",
      fontSize: "1px",
      ":hover": {
        backgroundColor: "transparent",
        color: "#333",
      },
    }),
  };

  const customComponent = {
    ClearIndicator: () => null,
    IndicatorSeparator: () => null,
  };

  return (
    <>
      {allProps.isCreatable ? (
        <Creatable
          {...field}
          {...allProps}
          components={customComponent}
          styles={customStyles}
        />
      ) : (
        <Select
          {...field}
          {...allProps}
          components={customComponent}
          styles={customStyles}
        />
      )}
    </>
  );
};

export default MultiSelect;
